import { render, staticRenderFns } from "./ItensAlmoxarifadoList.vue?vue&type=template&id=e51ee8b2"
import script from "./ItensAlmoxarifadoList.vue?vue&type=script&lang=js"
export * from "./ItensAlmoxarifadoList.vue?vue&type=script&lang=js"
import style0 from "./ItensAlmoxarifadoList.vue?vue&type=style&index=0&id=e51ee8b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports